<script>
import Layout from "../../../layouts/main";
import appConfig from "@/app.config";
import PageHeader from "@/components/page-header";
import ReportsHeader from "@/components/reports-header";
import moment from "moment";

export default {
  page: {
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    PageHeader,
    ReportsHeader,
  },
  data() {
    return {
      day: moment(new Date(Date.now())).format("YYYY-MM-DD hh:mm:ss a"),

      totalDebtors: [],
      limit: 20,
      page: 1,
      Debtors: [],
      total: [],
      accountingPeriods: [],
      amount: 0,
      totalOneMonth: 0,
      totalTwoMonth: 0,
      totalThreeMonth: 0,
      data: {},
    };
  },
  methods: {
    getDebtors(page) {
      this.http
        .post("transactions/debits-report", {
          accounting_period_id: this.data.accounting_period_id,
          limit: this.limit,
          page,
        })
        .then((res) => {
          this.Debtors = res.data;
          this.totalOneMonth = 0;
          this.totalTwoMonth = 0;
          this.totalThreeMonth = 0;
          this.Debtors.forEach((debtor) => {
            this.totalOneMonth += parseFloat(debtor.one_month);
            this.totalTwoMonth += parseFloat(debtor.two_month);
            this.totalThreeMonth += parseFloat(debtor.three_month);
          });
        });
    },
    getAccountingPeriods() {
      this.http.get("accounting-peroids").then((resp) => {
        if (resp) {
          this.accountingPeriods = resp.data;
        }
      });
    },
  },
  created() {
    this.getDebtors(1);
    this.getAccountingPeriods();
  },
};
</script>

<template>
  <Layout>
    <PageHeader
      :dir="$i18n.locale == 'ar' ? 'rtl' : ''"
      :title="$t('Debtors.title')"
    />
    <!-- <form @submit.prevent="getDebtors(1)">
      <div class="row">
        <div class="col">
          <label class="inline" for="fromJobTitle">{{
            $t("report.period")
          }}</label>
          <select
            v-model="data.accounting_period_id"
            type="date"
            class="form-control"
            id="fromJobTitle"
          >
            <option
              :value="period.id"
              v-for="period in accountingPeriods"
              :key="period"
            >
              {{ $t("report.period") + " : " + period?.start_date }}
            </option>
          </select>
        </div>
        <div class="col-auto" style="top: 20px">
          <button type="submit" class="btn btn-primary">
            {{ $t("popups.search") }}
          </button>
        </div>
        <div class="col"></div>
        <div class="col"></div>
      </div>
    </form> -->
    <div class="row mb-4">
      <div class="col-6"></div>
      <div class="col-6" style="top: 16px">
        <button
          class="btn float-end btn-success"
          @click="
            this.$store.dispatch('utils/printElement', {
              elementId: 'creditors-report',
              orientation: 'p',
            })
          "
        >
          <i class="fas fa-print"></i>
        </button>
      </div>
    </div>
    <div class="row mt-4">
      <div id="creditors-report" class="card p-3 card-body">
        <ReportsHeader :reportName="$t('reports.debtors')" />

        <div class="table-responsive">
          <table
            class="table table-centered table-nowrap table-striped table-hover align-middle"
            :dir="$i18n.locale == 'ar' ? 'rtl' : ''"
          >
            <thead>
              <tr
                class="text-light"
                style="background-color: #2a3042 !important"
              >
                <!-- <th>{{ $t("Creditor.account_id") }}</th> -->
                <th>{{ $t("Creditor.name") }}</th>
                <th>{{ $t("Creditor.befor30") }}</th>
                <th>{{ $t("Creditor.befor60") }}</th>
                <th>{{ $t("Creditor.befor90") }}</th>
              </tr>
            </thead>
            <tbody>
              <tr class="" v-for="debtor in Debtors" :key="debtor">
                <!-- <td>{{ debtor.code }}</td> -->
                <td>{{ debtor.name }}</td>
                <td>
                  <span>{{ Number(debtor.one_month).toLocaleString() }}</span>
                </td>
                <td>
                  <span>{{ Number(debtor.two_month).toLocaleString() }}</span>
                </td>
                <td>
                  <span>{{ Number(debtor.three_month).toLocaleString() }}</span>
                </td>
              </tr>
              <tr>
                <td></td>
                <td class="total-style">
                  {{ totalOneMonth.toLocaleString() }}
                </td>
                <td class="total-style">
                  {{ totalTwoMonth.toLocaleString() }}
                </td>
                <td class="total-style">
                  {{ totalThreeMonth.toLocaleString() }}
                </td>
              </tr>
            </tbody>
          </table>
          <table>
            <thead>
              <th>{{ $t("reports.report_date") }} :</th>
              <th>
                {{ day }}
              </th>
            </thead>
          </table>
        </div>
      </div>
    </div>
  </Layout>
</template>
<style scoped>
/*
.table,
td {
  border: 1px solid black;
}
*/
</style>
